import { motion } from "framer-motion";

interface props {
    contrastStyle?: boolean
}

const LoaderSpinner = ({contrastStyle = false}: props) => {
    return (
        <motion.div
            className={"loaders__loader-spinner" + (contrastStyle ? " loaders__loader-spinner--contrast": '')}
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        />
    );
}

export default LoaderSpinner;
